export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-primary-400 text-2xl"></i>
              </div>
              <span className="text-xl font-heading text-background-100 whitespace-nowrap">
                樱花漫画网
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed">
              樱花漫画网提供全集漫画大全，漫画全集免费完整版下拉式在线阅读，涵盖好看的韩漫日漫国漫全本漫画，一次看个够。每日更新热门连载，20000+全本漫画资源免费畅读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '功能特色', href: '#features' },
                { label: '常见问答', href: '#faq' },
                { label: '读者评价', href: '#comments' },
                { label: 'APP下载', href: '#app' },
                { label: '人气榜单', href: '#ranking' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">热门类型</h4>
            <div className="flex flex-col gap-2">
              {['热血漫画', '恋爱漫画', '韩漫精品', '日漫经典', '国漫崛起', '悬疑推理', '奇幻冒险', '校园青春'].map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              暂无具体合作站点信息，合作伙伴区域虚位以待。如有合作意向，欢迎通过联系我们页面进行沟通。
            </p>
            <div className="mt-4">
              <h4 className="font-heading text-base text-background-100 mb-3">关注我们</h4>
              <div className="flex items-center gap-3">
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-200 text-sm"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-background-200 text-sm"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-background-200 text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 樱花漫画网 - 全集漫画大全 | 漫画全集免费完整版下拉式在线阅读
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a href="#about" onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              关于我们
            </a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              常见问答
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}